import { News } from "../types";
import { getNewsCategoryById } from "../data/news";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/v1";

export const getNewsCategoryMeta = (category?: string) =>
  getNewsCategoryById(category);

export const getNewsImage = (item: Pick<News, "coverImage">) => {
  const coverImage = item.coverImage;

  if (!coverImage) {
    return "/images/placeholders/blog.jpg";
  }

  if (typeof coverImage === "string") {
    if (
      coverImage.startsWith("http://") ||
      coverImage.startsWith("https://") ||
      coverImage.startsWith("/")
    ) {
      return coverImage;
    }

    return `${API_URL}/news/public/cover/${coverImage}`;
  }

  if (coverImage._id) {
    return `${API_URL}/news/public/cover/${coverImage._id}`;
  }

  return "/images/placeholders/blog.jpg";
};

const escapeHtml = (value = "") =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const normalizeSeoPathSegment = (value = "") =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-")
    .replace(/[^\u0600-\u06FFa-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "") || "news";

export const getNewsSeoPathSegment = (item: Pick<News, "seoTitle" | "title">) =>
  normalizeSeoPathSegment(item.seoTitle || item.title);

export const getNewsAuthorLabel = (
  author?: News["author"],
  authorName?: News["authorName"],
) => {
  if (authorName) return authorName;
  if (!author) return "";
  if (typeof author === "string") return author;

  return author.fullName || author.mobile || author.nationalId || "";
};

export const formatNewsDate = (value?: string | null) => {
  if (!value) return "بدون تاریخ";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "بدون تاریخ";

  return new Intl.DateTimeFormat("fa-IR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
};

export const formatNewsTime = (value?: string | null) => {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat("fa-IR", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

export const getNewsContentHtml = (content?: string) => {
  if (!content) return "<p></p>";

  if (/<[a-z][\s\S]*>/i.test(content)) {
    return content;
  }

  return content
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map(
      (paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, "<br />")}</p>`,
    )
    .join("");
};
